<template>
  <div>
    <b-form @submit.prevent="evOnSubmit">
      <div class="row">
        <div class="col-md-12">
          <label-required-field label="NOME" />
          <b-input :disabled="isSelectedtItem" ref="autofocus" v-model="name" />
        </div>
        <div class="col-md-4">
          <LabelRequiredField label="UNIDADE DE MEDIDA" />
          <select
            :disabled="isSelectedtItem"
            v-model="unit_of_measurement_id"
            class="form-control"
            @change="handleChangeUnitOfMeasurementId($event.target.value)"
          >
            <option value="">SELECIONE...</option>
            <option
              v-for="unit in product_units_of_measurement"
              :key="unit.id"
              :value="unit.id"
            >
              {{ `${unit.name} (${unit.abbreviation})` }}
            </option>
          </select>
        </div>
        <div class="col-md-4">
          <label-required-field label="CATEGORIA" />
          <b-select
            :options="categories"
            text-field="name"
            value-field="id"
            v-model="stock_item_category_id"
          />
        </div>
        <div class="col-md-4">
          <label-required-field :label="sizeLabel" />
          <b-input v-model="size" />
        </div>
        <div class="col-md-4">
          <label>ESTOQUE MÍNIMO</label>
          <b-input type="text" v-model="minimum_stock" />
        </div>
        <div class="col-md-4">
          <label>ESTOQUE MÁXIMO</label>
          <b-input type="text" v-model="maximum_stock" />
        </div>
        <div class="col-md-12 p-0"></div>
        <div class="col-md-4">
          <label>CUSTO DO PRODUTO</label>
          <b-input
            type="text"
            v-model="product_cost"
            @keyup="handleValueProductCost"
          />
        </div>
        <div class="col-md-4">
          <label>LUCRO(%)</label>
          <b-input
            type="text"
            v-on:keyup="handleValueProfit"
            v-model="profit"
          />
        </div>
        <div class="col-md-4">
          <label>VALOR DA VENDA</label>
          <b-input
            type="text"
            v-model="sale_price"
            v-on:keyup="handleValueSalePrice"
          />
        </div>
        <div class="col-md-12">
          <label>REAJUSTE</label>
          <select class="form-control" v-model="readjustment">
            <option value="REAJUSTE_MANUAL">REAJUSTE MANUAL</option>
            <option value="REAJUSTE_VALOR_MEDIO">
              REAJUSTE VALOR MÉDIO (AUTOMÁTICO)
            </option>
            <option value="REAJUSTE_MAIOR_VALOR">
              REAJUSTE MAIOR VALOR (AUTOMÁTICO)
            </option>
          </select>
        </div>
        <div class="col-md-12 pb-0" v-if="permission('read', 'financial')">
          <label>CATEGORIA DO FINANCEIRO</label>
          <treeselect
            :options="[
              { id: '', label: 'NÃO INFORMAR', children: [] },
              ...finance_configuration_category,
            ]"
            placeholder="SELECIONE..."
            v-model="finance_configuration_category_id"
            noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
          />
        </div>
      </div>
      <errors-messages :errors="errors" />
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn-cancel @click="$bvModal.hide('new_product')" />
        </b-col>
        <b-col cols="auto">
          <v-btn-save :disabled="loading" :loading="loading" type="submit" />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import Treeselect from "@riophae/vue-treeselect";
import LabelRequiredField from "../../../Components/LabelRequiredField.vue";
import VBtnCancel from "../../../Components/VBtnCancel.vue";
import VBtnSave from "../../../Components/VBtnSave.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";
import permission from "../../../../lib/permission";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
} from "../../../../lib/format";

export default {
  name: "NewProduct",

  components: {
    VBtnSave,
    VBtnCancel,
    LabelRequiredField,
    ErrorsMessages,
    Treeselect,
  },

  props: {
    stock_item_categories: Array,
    stock_item_units_of_measurement: Array,
    product_units_of_measurement: Array,
    finance_configuration_category: Array,
  },

  data() {
    return {
      search: "",

      errors: [],
      loading: false,
      loadingProducts: false,

      isSelectedtItem: false,
      selectedtItem: false,

      finance_configuration_category_id: null,

      products: [],

      unit_of_measurement_id: "",
      name: "",
      stock_item_category_id: "",
      stock_item_unit_of_measurement_id: "",
      size: "",
      minimum_stock: "",
      maximum_stock: "",
      product_cost: "",
      profit: "",
      sale_price: "",
      readjustment: "REAJUSTE_MANUAL",
    };
  },

  created() {
    this.isSelectedtItem = false;
    this.selectedtItem = false;

    this.listProducts();
    this.evOnShow();
    this.evOnShown();
  },

  computed: {
    categories() {
      return [{ id: "", name: "SELECIONE" }, ...this.stock_item_categories];
    },

    unitsOfMeasurement() {
      return [
        { id: "", name: "SELECIONE" },
        ...this.stock_item_units_of_measurement,
      ];
    },

    sizeLabel() {
      const unit_of_measurement = this.stock_item_units_of_measurement.find(
        (unit) => unit.id === this.stock_item_unit_of_measurement_id
      );

      if (!unit_of_measurement) return "QUANTIDADE";

      return `QUANTIDADE EM ${unit_of_measurement.abbreviation}`;
    },
  },

  methods: {
    permission,

    handleValueProfit: function (e) {
      var profit = formatValueToPercentage(e.target.value);
      if (profit) {
        var current = formatValueToOnlyNumber(this.product_cost);
        var percentage = profit * current;
        var sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueProductCost: function (e) {
      this.product_cost = formatValueOnKeyUp(e.target.value);

      let { profit, product_cost } = this;

      if (profit) {
        let current = formatValueToOnlyNumber(product_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueSalePrice: function (e) {
      this.sale_price = formatValueOnKeyUp(e.target.value);
    },

    handleChangeUnitOfMeasurementId(id) {
      if (id) {
        let { product_units_of_measurement, unitsOfMeasurement } = this;

        let unit = product_units_of_measurement.find((item) => item.id == id);

        if (unit) {
          let unit_of_measurement = unitsOfMeasurement.find(
            ({ value }) => unit.value == value
          );

          if (unit_of_measurement) {
            this.stock_item_unit_of_measurement_id = unit_of_measurement.id;
          }
        }
      }
    },

    async listProducts() {
      try {
        this.loadingProducts = true;

        const params = { search: this.search };

        const response = await api.get(
          "/rest-home/product/list-not-linked-stock-item",
          {
            params,
          }
        );

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.products = data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingProducts = false;
      }
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.stock_item_category_id = "";
      this.stock_item_unit_of_measurement_id = "";
      this.name = "";
      this.size = "";
    },

    async evOnShown() {
      setTimeout(() => this.$refs.autofocus.focus(), 200);
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          name,
          unit_of_measurement_id,
          stock_item_unit_of_measurement_id,
          stock_item_category_id,
          size,
          selectedtItem,
          minimum_stock,
          maximum_stock,
          product_cost,
          profit,
          sale_price,
          readjustment,
          finance_configuration_category_id,
        } = this;

        const params = {
          name,
          unit_of_measurement_id,
          stock_item_unit_of_measurement_id,
          stock_item_category_id,
          size,
          selectedtItem,
          minimum_stock,
          maximum_stock,
          product_cost,
          profit,
          sale_price,
          readjustment,
          finance_configuration_category_id,
        };

        const response = await api.post(
          "/rest-home/stock/items/product",
          params
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("new_product");
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>